import React from 'react'
import './TouchBaseCard.scss';



 const ErrorResponseBody =( )=>{
    return (  
        <div className='response-body'>
        <div className='body-paragraph'>
            'Error 421'{' '}
        </div>
    </div>
    )
};
export default ErrorResponseBody ;